export const tutors = [
  {
    id: 1,
    name: 'Mrs Shao Xinmo',
    nameZh: '邵老师',
    photo: '', // Photo removed at tutor's request
    subject: 'Chinese 华文',
    experience: '20+ years experience in education sector since 2003',
    experienceZh: '自2003年起拥有超过20年的教育经验',
    qualifications: [
      'Further language competency obtained from Nanyang Technological University (NTU) in 2017',
      '新加坡南洋理工大学语言教育专业证书',
    ],
    phone: '+65 96873957',
    email: 'xinmo688@gmail.com',
    bio: 'With over two decades of dedicated experience in Chinese language education, Mrs Shao brings a wealth of knowledge and passion to every classroom. Her teaching approach combines traditional methods with modern techniques, ensuring students build a strong foundation while staying engaged and motivated.',
    bioZh: '邵老师拥有超过二十年的华文教学经验，将丰富的知识和热情带入每一堂课。她的教学方法结合传统与现代技巧，擅长因材施教，确保学生在打好扎实基础的同时保持学习兴趣。',
    philosophy: 'Every student has the potential to excel in Chinese. Through patience, encouragement, and structured learning, we unlock that potential together.',
    philosophyZh: '每个学生都有学好华文的潜力。通过耐心、鼓励和系统化的教学，我们一起发掘这种潜力。',
  },
  {
    id: 2,
    name: 'Ms Yang',
    nameZh: '杨老师',
    photo: '',
    subject: 'Chinese / Higher Chinese 华文 / 高级华文',
    experience: 'near 10 years of tuition experience',
    experienceZh: '近10年的补习教学经验',
    qualifications: [
      "Bachelor's Degree in Chinese Studies from SUSS (First Class Honours)",
      '新加坡新跃社科大学中文系学士学位（一等荣誉）',
      'Mrs Wong-Mah Jia Lan Confucianism Award Recipient (Nanyang Confucian Association)',
      '南洋孔教会黄马家兰儒学奖获得者',
    ],
    phone: '+65 96873957',
    email: 'xinmo688@gmail.com',
    bio: "Ms Yang holds a Bachelor's Degree in Chinese Studies from the Singapore University of Social Sciences (SUSS) with First Class Honours. She is a proud recipient of the Mrs Wong-Mah Jia Lan Confucianism Award from the Nanyang Confucian Association, a testament to her academic excellence in Chinese philosophy and Confucian thought. With nearly 10 years of tuition experience, Ms Yang specialises in teaching Higher Chinese, helping students achieve outstanding results in both Chinese and Higher Chinese examinations.",
    bioZh: '杨老师毕业于新加坡新跃社科大学中文系，获一等荣誉学士学位。她荣获南洋孔教会黄马家兰儒学奖，充分证明了她的学术实力。杨老师拥有近10年的补习经验，擅长教授普华及高级华文，帮助学生在华文和高级华文考试中取得优异成绩。',
    philosophy: 'Language is the gateway to culture. When students understand the beauty of Chinese culture, they naturally fall in love with the language.',
    philosophyZh: '语言是通往文化的桥梁。当学生了解中华文化之美时，他们自然而然地爱上华文。',
  },
];
